import {
	type CanvasRuntimeParams,
	type Disposable,
	registerCanvasRuntimeFactory as _registerCanvasRuntimeFactory,
} from "@moment/state";

import { CanvasRuntimeManager } from "../../components/canvas/easel/runtime/CanvasRuntimeManager";
import { UnsafeNoOpPageStorageBridge } from "../moment-std-lib/pageStorage";

/**
 * Factory function that creates a CanvasRuntimeManager instance.
 *
 * This is registered with the state package's `registerCanvasRuntimeFactory`
 * so that the state package can manage runtime lifecycles without depending
 * on the actual CanvasRuntimeManager implementation.
 */
const canvasRuntimeFactory = (params: CanvasRuntimeParams): CanvasRuntimeManager => {
	const { documentId, pageId, documentInteractionMode, query, mutation } = params;

	return new CanvasRuntimeManager(
		process.env.APP_ENV as NonNullable<MomentAppEnv>,
		new UnsafeNoOpPageStorageBridge({
			id: documentId,
			pageId,
		}),
		documentInteractionMode,
		undefined,
		undefined,
		query,
		mutation
	);
};

/**
 * Registers the canvas runtime factory with the state package.
 *
 * This must be called during app initialization (in Providers.tsx).
 */
export const registerCanvasRuntimeFactory = (): void => {
	_registerCanvasRuntimeFactory(
		canvasRuntimeFactory as (params: CanvasRuntimeParams) => Disposable
	);
};
